import {
	CHECK_AVAILABILITIES,
	CLEAR_QUOTATION,
	FETCH_FLIGHT_OPTIONS,
	PRE_BOOK,
	RESET_FLIGHTS_FILTER,
	RESET_FLIGHTS_PAGE_SIZE,
	SET_FLIGHTS_FILTER_BY,
	SET_FLIGHTS_SORT_BY,
	SHOW_MORE_FLIGHTS,
} from "../../../actionTypes";
import env from "app/utils/env";
import axios from "axios";
import {
	SHOW_ALL_ACTIVITIES,
	SHOW_FLEX_RATES_MODAL,
	SHOW_MORE_ACCOMMODATIONS,
} from "app/pages/Booking/Quotation/quotationActionTypes";
import { getCredentials } from "app/utils/auth";
import { AB_TESTS_STATUS } from "app/constants";

export const clearQuotation = () => {
	return {
		type: CLEAR_QUOTATION,
	};
};

export const fetchFlightOptions = payload => {
	return {
		type: FETCH_FLIGHT_OPTIONS,
		promise: axios.post(`${env("QUOTE_API_URL")}/flightOptions`, payload, {
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const checkAvailibilities = (quotationPayload, abTests) => {
	const { token } = getCredentials();

	// @see https://perfectstay.atlassian.net/browse/FUX-21
	// On a besoin de passer le token uniquement pour savoir si un operateur est connecté ou non.
	// On effet, le token contiendra l'email de l'operator et le service de quote nous renverra l'email de l'operator
	const headers = {
		Authorization: token,
		"Content-type": "application/json",
	};

	return {
		type: CHECK_AVAILABILITIES,
		promise: axios.post(
			`${env("QUOTE_API_URL")}/quote`,
			{
				...quotationPayload,
				...(abTests.status === AB_TESTS_STATUS.SUCCESS && {
					abTests: abTests.activeCampaigns,
				}),
			},
			{
				headers,
			}
		),
	};
};

export const setFlightsSortBy = property => {
	return {
		type: SET_FLIGHTS_SORT_BY,
		sortBy: property,
	};
};

export const setFlightsFilterBy = properties => {
	return {
		type: SET_FLIGHTS_FILTER_BY,
		filterBy: properties,
	};
};

export const showMoreFlights = () => {
	return {
		type: SHOW_MORE_FLIGHTS,
	};
};

export const showAllActivities = () => {
	return {
		type: SHOW_ALL_ACTIVITIES,
	};
};

export const resetFlightsPageSize = () => {
	return {
		type: RESET_FLIGHTS_PAGE_SIZE,
	};
};

export const resetFlightsFilter = filtersValues => {
	return { type: RESET_FLIGHTS_FILTER, filtersValues };
};

export const preBook = data => {
	return {
		type: PRE_BOOK,
		promise: axios.post(`${env("QUOTE_API_URL")}/preBook`, data, {
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const showMoreAccommodations = () => {
	return {
		type: SHOW_MORE_ACCOMMODATIONS,
	};
};

export const showFlexRatesModal = isFlexRatesModalOpened => {
	return {
		type: SHOW_FLEX_RATES_MODAL,
		isFlexRatesModalOpened,
	};
};
